export function setAllStations(state, all) {
  state.all = all;
}
